// import Permission from "../../../../common/components/auth/Permission";
// import SubTablePurchaseOrder from "../tables/SubTablePurchaseOrder";
import { usePurchaseOrderDashboardContext } from "./PurchaseOrder.context";

import './index.scss'
import InfoTablePurchaseOrder from "../tables/InfoTablePurchaseOrder";
import { IPurchaseOrder } from "@/types/purchaseOrder.types";
import Loading from "@/common/components/ui/loading/Loading";

export function PurchaseOrderDashboard() {
  const { purchaseOrder, isLoading } = usePurchaseOrderDashboardContext();

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div className="flex flex-col items-center h-full overflow-y-auto bg-white  text-black  p-2">     
        <InfoTablePurchaseOrder purchaseOrder={purchaseOrder as IPurchaseOrder} />
    </div>

  )
}
